<div class="container-fluid">
	<app-alert-line [alertLineData]="alertLine"></app-alert-line>

	<h1>Détail de la société '{{companyName}}'</h1>
	<br>

	<ng-template [ngIf]="hasFolder()">
		<div class="row">
			<div class="col-12">
				<h2>Liste des dossiers</h2>
			</div>
		</div>
		<div class="p-mb-3">
			<p-button type="button" icon="pi pi-chevron-left" (onClick)="prevFolder()" [disabled]="isFirstPageFolder()" styleClass="p-button-text"></p-button>
			<p-button type="button" icon="pi pi-refresh" (onClick)="resetFolder()" styleClass="p-button-text"></p-button>
			<p-button type="button" icon="pi pi-chevron-right" (onClick)="nextFolder()" [disabled]="isLastPageFolder()" styleClass="p-button-text"></p-button>
		</div>
		<p-table
			[value]="datasFolder"
			[columns]="columnsFolder"
			sortField="name"
			[paginator]="true"
			[rows]="rowsFolder"
			[showCurrentPageReport]="true"
			[(first)]="firstFolder"
			currentPageReportTemplate="Affichage de {first} à {last} sur {totalRecords} dossier(s)"
			[rowsPerPageOptions]="[10,25,50,100]"
			styleClass="p-database-striped"
			[autoLayout]=true
			#dt>
			<ng-template pTemplate="header" let-columnsFolder>
				<tr>
					<th *ngFor="let col of columnsFolder" [pSortableColumn]="col.sort">
						{{col.header}}
						<p-sortIcon [field]="col.field"></p-sortIcon>
					</th>
					<th>Actions</th>
				</tr>
				<tr>
					<th>
						<input pInputText type="text" (input)="dt.filter(filterColumns($event), 'name', 'contains')" placeholder="Recherche par nom" class="p-columns-filter">
					</th>
					<th>
						<p-dropdown [options]="folderStateChoice" appendTo="body" (onChange)="dt.filter($event.value, 'state', 'equals')" styleClass="p-column-filter" placeholder="Choix de l'état" [showClear]="true">
							<ng-template let-option pTemplate="item">
								<span [class]="'customer-badge status-'+option.value">{{option.label}}</span>
							</ng-template>
						</p-dropdown>
					</th>
					<th>
						<input pInputText type="text" (input)="dt.filter(filterColumns($event), 'path', 'contains')" placeholder="Recherche par chemin" class="p-columns-filter">
					</th>
					<th>
						&nbsp;
					</th>
					<th>&nbsp;</th>
				</tr>
			</ng-template>
			<ng-template pTemplate="body" let-folder let-folders="datasFolder">
				<tr>
					<td>
						<a [routerLink]="['/folder-detail-admin', folder['_id']]">{{folder["name"]}}</a>
					</td>
					<td>
						<span *ngIf="folder['state'] == 'D'" class="ls-state-waiting">En attente</span>
						<span *ngIf="folder['state'] == 'R'" class="ls-state-running">En cours</span>
						<span *ngIf="folder['state'] == 'E'" class="ls-state-ended">Terminé</span>
						<span *ngIf="folder['state'] == 'X'" class="ls-state-inactive">Désactivé</span>
					</td>
					<td>
						{{folder["path"]}}
					</td>
					<td>
						{{folder["endDate"]}}
					</td>
					<td>
						<button matTooltip="Editer" class="btn btn-primary material-item" type="button" mat-raised-button (click)="doEditFolder(folder['name'], folder._id, folder['endDateVal'])"><i class="material-icons md-24 icons" tooltips tooltip-template="Bonjour">edit</i></button>
						&nbsp;
						<button matTooltip="Editer le mail envoi" class="btn btn-info material-item" type="button" mat-raised-button (click)="doEditFolderMail(folder._id, folder['name'])"><i class="material-icons md-24 icons">rate_review</i></button>
						&nbsp;
						<button [disabled]="folder['state'] != 'R'" matTooltip="Envoyer un rappel" class="btn btn-warning material-item" type="button" mat-raised-button (click)="doSendFolderReminder(folder._id, folder['name'])"><i class="material-icons md-24 icons">add_alert</i></button>
						&nbsp;
						<button [disabled]="folder['state'] !='R'" matTooltip="Envoyer une notification suite à mise à jour des fichiers" class="btn btn-warning material-item" type="button" mat-raised-button (click)="doSendForUpdateFolder(folder._id)"><i class="material-icons md-24 icons">update</i></button>
						&nbsp;
						<button matTooltip="Mettre à jour les droits" class="btn btn-primary material-item" type="button" mat-raised-button (click)="doEditRightsFolder(folder['name'], folder._id)"><i class="material-icons md-24 icons">lock</i></button>
						<span *ngIf="folder['state']=='D' || folder['state']=='E'" class="ls-button-sep">&nbsp;&nbsp;</span>
						<button *ngIf="folder['state']=='D'" matTooltip="Lancer le projet" class="btn btn-success material-item" type="button" mat-raised-button (click)="doStartFolder(folder._id, folder.name)"><i class="material-icons md-24 icons">play_arrow</i></button>
						<button *ngIf="folder['state']=='E'" matTooltip="Relancer le projet" class="btn btn-success material-item" type="button" mat-raised-button (click)="doRestartFolder(folder._id, folder.name)"><i class="material-icons md-24 icons">restart_alt</i></button>
						&nbsp;
						<button matTooltip="Activer le projet" class="btn btn-danger material-item" type="button" mat-raised-button (click)="doActivateFolder(folder._id)" *ngIf="folder['state'] == 'X'"><i class="material-icons md-24 icons">power</i></button>
						<button matTooltip="Désactiver le projet" class="btn btn-danger material-item" type="button" mat-raised-button (click)="doDeactivateFolder(folder._id)" *ngIf="folder['state'] != 'X'"><i class="material-icons md-24 icons">power_off</i></button>
					</td>
				</tr>
			</ng-template>
		</p-table>
		<br>
	</ng-template>

	<ng-template [ngIf]="!hasFolder()">
		<div class="row">
			<div class="col-12">
				<h2>Pas de dossier</h2>
				<p>Votre société ne contient pas de dossier.</p>
			</div>
		</div>
	</ng-template>

	<div class="row">
		<div class="col-12">
			<button matTooltip="Ajouter un dossier" mat-raised-button type="button" class="btn btn-primary material-item" (click)="doAddFolder()"><i class="material-icons md-24 icons">add_box</i> Ajouter un dossier ...</button>
		</div>
	</div>
	<br><br>
	<hr>
	<ng-template [ngIf]="hasUser()">
		<div class="row">
			<div class="col-12">
				<h2>Liste des utilisateurs</h2>
			</div>
		</div>

		<div class="p-mb-3">
			<p-button type="button" icon="pi pi-chevron-left" (onClick)="prevUser()" [disabled]="isFirstPageUser()" styleClass="p-button-text"></p-button>
			<p-button type="button" icon="pi pi-refresh" (onClick)="resetUser()" styleClass="p-button-text"></p-button>
			<p-button type="button" icon="pi pi-chevron-right" (onClick)="nextUser()" [disabled]="isLastPageUser()" styleClass="p-button-text"></p-button>
		</div>
		<p-table [value]="datasUser"
			[columns]="columnsUser"
			sortField="username"
			[paginator]="true"
			[rows]="rowsUser"
			[showCurrentPageReport]="true"
			[(first)]="firstUser"
			currentPageReportTemplate="Affichage de {first} à {last} sur {totalRecords} utilisateur(s)"
			[rowsPerPageOptions]="[10,25,50,100]"
			styleClass="p-datatable-striped"
			[autoLayout]=true
			#dt>
			<ng-template pTemplate="header" let-columnsUser>
				<tr>
					<th *ngFor="let col of columnsUser" [pSortableColumn]="col.sort">
						{{col.header}}
						<p-sortIcon [field]="col.sort"></p-sortIcon>
					</th>
					<th>Actions</th>
				</tr>
				<tr>
					<th>
						<input pInputText type="text" (input)="dt.filter(filterColumns($event), 'username', 'contains')" placeholder="Recherche par identifiant" class="p-column-filter">
					</th>
					<th>
						<p-dropdown [options]="roleChoice" appendTo="body" (onChange)="dt.filter($event.value, 'role', 'equals')" styleClass="p-column-filter" placeholder="Choix du rôle" [showClear]="true">
							<ng-template let-option pTemplate="item">
								<span [class]="'company-badge status-'+option.value">{{option.label}}</span>
							</ng-template>
						</p-dropdown>
					</th>
					<th>
						<input pInputText type="text" (input)="dt.filter(filterColumns($event), 'name', 'contains')" placeholder="Recherche par nom" class="p-column-filter">
					</th>
					<th>
						<input pInputText type="text" (input)="dt.filter(filterColumns($event), 'firstname', 'contains')" placeholder="Recherche par prénom" class="p-column-filter">
					</th>
					<th>
						<p-dropdown [options]="userStateChoice" appendTo="body" (onChange)="dt.filter($event.value, 'active', 'equals')" styleClass="p-column-filter" placeholder="Choix de l'état" [showClear]="true">
							<ng-template let-option pTemplate="item">
								<span [class]="'company-badge status-'+option.value">{{option.label}}</span>
							</ng-template>
						</p-dropdown>
					</th>
					<th style="width:400px;">&nbsp;</th>
				</tr>
			</ng-template>
			<ng-template pTemplate="body" let-usr let-usrs="datasUser">
				<tr>
					<td>
						<a [routerLink]="['/user-detail', usr['_id']]">{{usr.username}}</a>
					</td>
					<td>
						<span class="ls-role-user" *ngIf="usr['role']=='U'">Utilisateur</span>
						<span class="ls-role-engineer" *ngIf="usr['role']=='I'">Ingénieur</span>
						<span class="ls-role-admin" *ngIf="usr['role']=='A'">Administrateur</span>
					</td>
					<td>
						<span *ngIf="usr['name'] == ''">-</span>
						<span *ngIf="usr['name'] != ''">{{usr["name"]}}</span>
					</td>
					<td>
						<span *ngIf="usr['firstname'] == ''">-</span>
						<span *ngIf="usr['firstname'] != ''">{{usr["firstname"]}}</span>
					</td>
					<td>
						<span class="ls-state-active" *ngIf="usr['active']">Actif</span>
						<span class="ls-state-inactive" *ngIf="!usr['active']">Désactivé</span>
					</td>
					<td>
						<button matTooltip="Editer" mat-raised-button type="button" class="btn btn-primary material-item" (click)="doEditUser(usr['_id'], usr.username)"><i class="material-icons md-24 icons">edit</i></button>
						&nbsp;
						<button *ngIf="usr['username'] != this.cookieService.get(this.constantsModule.cookieUser)" [disabled]="!usr['active']" matTooltip="Réinitialiser le mot de passe" mat-raised-button type="button" class="btn btn-info material-item" (click)="doGenerateNewUserPassword(usr._id, usr.username)"><i class="material-icons md-24 icons">password</i></button>
						&nbsp;
						<button *ngIf="usr['username'] != this.cookieService.get(this.constantsModule.cookieUser)" [disabled]="usr['active']" matTooltip="Activer la société" mat-raised-button type="button" class="btn btn-success material-item" (click)="doActivateUser(usr._id)"><i class="material-icons md-24 icons">power</i></button>
						&nbsp;
						<button *ngIf="usr['username'] != this.cookieService.get(this.constantsModule.cookieUser)" [disabled]="!usr['active'] || usr['username'] == this.cookieService.get(this.constantsModule.cookieUser)" matTooltip="Désactiver la société" mat-raised-button type="button" class="btn btn-danger material-item" (click)="doDeactivateUser(usr._id)"><i class="material-icons md-24 icons">power_off</i></button>
						
					</td>
				</tr>
			</ng-template>
		</p-table>
		<br>
	</ng-template>

	<ng-template [ngIf]="!hasUser()">
		<div class="row">
			<div class="col-12">
				<h2>Pas d'utilisateur</h2>
				<p>Votre société ne contient pas d'utilisateur.</p>
			</div>
		</div>
	</ng-template>

	<div class="row">
		<div class="col-12">
			<button matTooltip="Ajouter un utilisateur" mat-raised-button type="button" class="btn btn-primary material-item" (click)="doAddUser()"><i class="material-icons md-24 icons">add_box</i> Ajouter un utilisateur ...</button>
		</div>
	</div>
	<br><br>
</div>
